var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProforma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.274 17V7.9H9.979C10.473 7.9 10.9193 8.02567 11.318 8.277C11.7253 8.51967 12.0503 8.85333 12.293 9.278C12.5357 9.70267 12.657 10.175 12.657 10.695C12.657 11.215 12.5357 11.6873 12.293 12.112C12.0503 12.5367 11.7253 12.879 11.318 13.139C10.9193 13.3903 10.473 13.516 9.979 13.516H7.678V17H6.274ZM7.678 12.164H9.953C10.187 12.164 10.3993 12.099 10.59 11.969C10.7807 11.8303 10.9323 11.6527 11.045 11.436C11.1663 11.2107 11.227 10.9637 11.227 10.695C11.227 10.4263 11.1663 10.1837 11.045 9.967C10.9323 9.75033 10.7807 9.577 10.59 9.447C10.3993 9.317 10.187 9.252 9.953 9.252H7.678V12.164Z",
    fill: "#262F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8252 3H15.75V18.4248L13.1748 21H2.25V5.5752L4.8252 3ZM14.625 17.9502V4.125H5.2998L3.375 6.0498V19.875H12.7002L14.625 17.9502Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProforma);
export default __webpack_public_path__ + "static/media/proforma.7c7ef524f661cbda170a43ba18be612d.svg";
export { ForwardRef as ReactComponent };